import { useBackgroundQuery } from '@apollo/client/react';

import { TaskCriticalityEnum, TaskStatusEnum } from 'src/graphql/schema';
import { TasksDocument } from 'src/graphql/actions/tasks/tasks.query';
import { withSuspense } from 'src/hoc';

import { UNREAD_TASKS_LIMIT } from '../model';

import UnreadTasksCard from './UnreadTasksCard';

const getUnreadTasksOptions = (criticality: TaskCriticalityEnum) => ({
  fetchPolicy: 'cache-and-network' as const,
  variables: {
    status: TaskStatusEnum.Unread,
    criticality,
    page: 1,
    perPage: UNREAD_TASKS_LIMIT,
  },
});

const UnreadTasksContainer = () => {
  const [highQueryRef] = useBackgroundQuery(TasksDocument, getUnreadTasksOptions(TaskCriticalityEnum.High));
  const [mediumQueryRef] = useBackgroundQuery(TasksDocument, getUnreadTasksOptions(TaskCriticalityEnum.Medium));
  const [lowQueryRef] = useBackgroundQuery(TasksDocument, getUnreadTasksOptions(TaskCriticalityEnum.Low));

  return (
    <UnreadTasksCard
      queryRefs={{
        [TaskCriticalityEnum.High]: highQueryRef,
        [TaskCriticalityEnum.Medium]: mediumQueryRef,
        [TaskCriticalityEnum.Low]: lowQueryRef,
      }}
    />
  );
};

export default withSuspense(UnreadTasksContainer, () => null);
